import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap/dist/js/bootstrap.bundle"
import 'popper.js'
import "./font/Poppins/all.css"
import axios from 'axios'

axios.defaults.baseURL = 'https://aofbackend.nextcapital.com.pk/api/v1/'
//axios.defaults.baseURL = 'https://aofbackend.nextventures.com.pk/api/v1/'
axios.defaults.url = '103.31.81.9:8080/api/v1/'


axios.defaults.headers =
{
  'x-auth-token': localStorage.getItem('token'),
  'Content-Type': 'application/json'
}





ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
